module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table wh100 \">\n    ")
    ;  _.each(options, function(option) { 
    ; __append("\n    ")
    ; 
      var attributes = Html.attributes(_.reduce(option, function(result, value, name) {
          result['data-control-' + name] = value;
          return result;
      }, {}));
      
    ; __append("\n    <div class=\"section\">\n        <div class=\"title\">")
    ; __append(escapeFn( option.title ))
    ; __append("</div>\n        <div>\n            <div ")
    ; __append( attributes )
    ; __append(">\n                ")
    ; __append(escapeFn( option.value ))
    ; __append("\n            </div>\n        </div>\n    </div>\n    ")
    ;  }) 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}